'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import SvgArrowdownFill from '@common/icon/SvgArrowdownFill';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { DEFAULT_DONATION_SEARCH_CATEGORY, DEFAULT_SEARCH_CATEGORY, getSearchCategoryGroups, isDonationSearchCategory, SEARCH_CATEGORY_ITEMS, SEARCH_CATEGORY_QUERY_KEY, type SearchScope } from './constants';
export function SearchCategoryDropdown(t0) {
  const $ = _c(21);
  const {
    scope
  } = t0;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const {
    replace
  } = useCustomRouter();
  let t1;
  if ($[0] !== scope) {
    t1 = getSearchCategoryGroups(scope);
    $[0] = scope;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groups = t1;
  let t2;
  if ($[2] !== scope || $[3] !== searchParams) {
    const rawValue = searchParams.get(SEARCH_CATEGORY_QUERY_KEY) ?? DEFAULT_SEARCH_CATEGORY;
    t2 = scope === "donation" && !isDonationSearchCategory(rawValue) ? DEFAULT_DONATION_SEARCH_CATEGORY : rawValue;
    $[2] = scope;
    $[3] = searchParams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const currentValue = t2;
  let t3;
  if ($[5] !== currentValue) {
    t3 = SEARCH_CATEGORY_ITEMS.find(item => item.value === currentValue)?.label ?? "\uC804\uCCB4";
    $[5] = currentValue;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const currentLabel = t3;
  let t4;
  if ($[7] !== pathname || $[8] !== replace || $[9] !== searchParams) {
    t4 = value => {
      const params = new URLSearchParams();
      const keyword = searchParams.get("q");
      if (keyword) {
        params.set("q", keyword);
      }
      if (value !== DEFAULT_SEARCH_CATEGORY) {
        params.set(SEARCH_CATEGORY_QUERY_KEY, value);
      }
      const query = params.toString();
      replace(`${pathname}${query ? `?${query}` : ""}`, {
        scroll: false
      });
    };
    $[7] = pathname;
    $[8] = replace;
    $[9] = searchParams;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleChange = t4;
  let t5;
  if ($[11] !== currentLabel) {
    t5 = <span className="whitespace-nowrap font-500 text-Gray-900 typo-body3 mobile-tablet:min-w-0 mobile-tablet:truncate mobile-tablet:font-400 mobile-tablet:tracking-[-0.28px] mobile-tablet:text-Gray-700 mobile-tablet:typo-body4">{currentLabel}</span>;
    $[11] = currentLabel;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgArrowdownFill className="size-16 shrink-0 text-Gray-900 mobile-tablet:text-Gray-700" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5) {
    t7 = <div className="flex min-w-0 items-center gap-4 rounded-pill px-12 py-4 mobile-tablet:px-8">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== currentValue || $[17] !== groups || $[18] !== handleChange || $[19] !== t7) {
    t8 = <DropdownMenu type="custom" className="mobile-tablet:w-auto mobile-tablet:min-w-80 mobile-tablet:max-w-100" groups={groups} value={currentValue} onChange={handleChange}>{t7}</DropdownMenu>;
    $[16] = currentValue;
    $[17] = groups;
    $[18] = handleChange;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}